var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"data-luko-tracking":"QuoteSlice"}},[_c('em',[_vm._v(_vm._s(_vm.quote))]),_vm._v("\n  "+_vm._s(_vm.author)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }